export const mPosFeatures = {
  table: { id: 190, featureName: 'Table' },
  'table-status': { id: 191, featureName: 'Table Status' },
  'switch-floors': { id: 192, featureName: 'Switch Floors' },
  'view-seating-capacity': { id: 193, featureName: 'View Seating Capacity' },
  'service-charges': { id: 194, featureName: 'Service Charges' },
  'assign-server': { id: 195, featureName: 'Assign Server' },
} as const;
export const mPosFeaturesList = Object.entries(mPosFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: 'System',
}));
export const mPosFeaturesNewList = [
  { moduleId: 23, featureId: mPosFeatures['table'].id },
  { moduleId: 23, featureId: mPosFeatures['table-status'].id },
  { moduleId: 23, featureId: mPosFeatures['switch-floors'].id },
  { moduleId: 23, featureId: mPosFeatures['view-seating-capacity'].id },
  { moduleId: 25, featureId: mPosFeatures['service-charges'].id },
  { moduleId: 23, featureId: mPosFeatures['assign-server'].id },
  { moduleId: 15, featureId: mPosFeatures['assign-server'].id },
];
